import { useQuery } from "react-query"
import styled from "styled-components"
import { getActiveVacancyList } from "../../../services"
import { AosWrapper } from "../../molecules/AosWrapper"
import Fallback from "../../../public/assets/imgs/fallback.svg"
import { UserButton } from "@project/shared"
import { useRouter } from "next/router"
import { WeAreHiring } from "../WeAreHiring"
import { Descripition, Headline, StyledGradientTitle } from "../../../utils"

const Wrapper = styled.div`
  width: 100%;
  padding: 80px;
  display: flex;
  justify-content: center;
  background: ${(props) => props.theme.bgRadialDeepBlue2};

  @media (max-width: 641px) {
    padding: 50px 20px;
  }
  .fallback {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    @media (max-width: 641px) {
      width: 100%;
      align-items: flex-start;
    }

    .submit-button {
      width: 210px;
    }
  }
`

const DescripitionText = styled(Descripition)`
  margin-bottom: 20px;
`
const FallbackWrapper = styled.div`
  margin-bottom: 20px;

  @media (max-width: 600px) {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
`

const HiringSection: React.FC = () => {
  const router = useRouter()
  const { data: vacancyData } = useQuery(
    ["active-vacancy-list"],
    getActiveVacancyList,
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  )

  return (
    <AosWrapper>
      {vacancyData?.length ? (
        <>
          <WeAreHiring vacancyData={vacancyData} />
        </>
      ) : (
        <Wrapper>
          <div className="fallback">
            <FallbackWrapper>
              <Fallback />
            </FallbackWrapper>
            <Headline>
              {"We're currently closed for "}
              <StyledGradientTitle>{"Job Opportunities"}</StyledGradientTitle>
            </Headline>
            <DescripitionText>
              {
                "Sorry to deflate your hopes of joining our team as we don't have any job vacancy for\nyou right now.  Please drop your CV here and we will contact you as soon as we\nhave suitable position for you."
              }
            </DescripitionText>

            <UserButton
              buttonType={"secondary"}
              className={"submit-button"}
              onClick={() => router.push("#job-apply-form")}
            >
              {"Drop your CV"}
            </UserButton>
          </div>
        </Wrapper>
      )}
    </AosWrapper>
  )
}

export { HiringSection }
